module.exports = __webpack_public_path__ + "img/comprobantes.4826f5e0.png";